<template>
  <section>
  <div class="container">
    <div class="error-content">
     <h2>Page Not Found</h2>
     <p>The page you are looking for has been moved or no longer exists.</p>
     <a href="#"><h3>Return Home</h3></a>
    </div><!-- end error-content -->
    </div>
  </section>
</template>
<script>
export default {
  name :'notfound',
  data() {
    return {
      message : 'The page was not found!'
    }
  }
}
</script>

<style>
/*error page */
.error-content {
  background-color:#F7F7F7;
  padding:20px;
  margin-top: 100px;
  color: #5F6A70;
  border-radius: 5px;

}
.error-content h2{
 color: #5F6A70;
 font-family: 'Lato',sans-serif;
 line-height: 30px;
 font-weight: bold;
}
.error-content p {
  color: #B1B1B1;
  font-family: 'Lato',sans-serif;
  font-size: 14px;
  padding-bottom: 10px;
}
.error-content a h3 {
  border:1px solid #E07912;
  color: #ffffff;
  padding: 8px 15px;
  display: table;
  border-radius: 5px;
  background: #F2AA62;
  margin-top: 16px;
  text-decoration: none;
}
.error-content a h3:hover {
  background:#F5C492;
}
</style>



// WEBPACK FOOTER //
// NotFound.vue?35f24e83